/*eslint no-script-url: 0 */
import React, { Component } from "react";
import { Scrollbars } from 'react-custom-scrollbars';
import Constants from '../../Config/Config';

class Cat extends Component {

  constructor(props) {
    super(props);
    this.state = {
      error: null,
      popularCatCount: 0
    }
  }

  fetchCat() {
    var self = this;
    const URL = Constants.URL.root+'/wp-content/themes/justpictureframing/data/categories.json';
    fetch(URL)
    .then(response => {
      if (!response.ok) {
        throw Error('Network request failed.')
      }
      return response;
    })
    .then(data => data.json())
    .then(data => {
      //console.log(data);
      const categories = data;
      var popularCatCountVar = 0;
      categories.some( ( item ) =>
        popularCatCountVar = item.id === 16 ? item.count : 0
      )
      self.setState({ popularCatCount: popularCatCountVar });
      self.props.dispatch({
        type: 'SET_STATE',
        state: {
          catProCount: popularCatCountVar
        }
      })
      var productsCount = 0;
      categories.map(item => (
        //console.log(item.count)
        productsCount = productsCount + item.count
      ))
      //console.log(catCount)
      self.dispatchCatData(categories, productsCount);
    }, (ex) => {
      //self.setState({ error: err.message });
    })
  }

  dispatchCatData(CatData, productsCount) {
    const dataCat = CatData;
    this.props.dispatch({
      type: 'SET_STATE',
      state: {
        frameCategories: dataCat,
        productsCount: productsCount
      }
    })
  }

  setCategory = (category, count) => {
    this.props.slidesToShow(count);
    this.props.dispatch({
      type: 'SET_STATE',
      state: {
        displayCategory: category,
        catProCount: count
      }
    })
  };

  componentDidMount() {
    this.fetchCat();
  }

  render() {
    //console.log(this.props.productsCount)
    const {displayCategory} = this.props;
    return (
      <div className="col-sm-3">
        <Scrollbars
          autoHeight
          autoHeightMin={0}
          autoHeightMax={255}
        >
          <ul className="nav nav-tabs">
            <li key="16">
              <a href="#!" className={displayCategory === 16 ? 'selected-cat' : ''} category="Most Popular" onClick={this.setCategory.bind(this, 16, this.state.popularCatCount)}>Most Popular ({this.state.popularCatCount})</a>
            </li>
            {this.props.frameCategories.filter( ( item ) =>
                item.get('id') !== 16
              ).map(item => (
                <li key={item.get('id')}>
                  <a href="#!" className={displayCategory === item.get('id') ? 'selected-cat' : ''} category={item.get('name')} onClick={this.setCategory.bind(this, item.get('id'), item.get('count'))}>{item.get('name')} ({item.get('count')})</a>
                </li>
            ))}
          </ul>
        </Scrollbars>
      </div>
    );
  }
}
export default Cat;